export default {
    name: "PlatformCustomerManage",
    data() {
        return {
            searchForm: {
                companyName: '',
                businessType: null,
                applyTime: '',
                auditTime: '',
                auditResult: '',
                pageIndex: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0
        }
    },
    created(){
        let conditionParam = this.$routerUtil.getParam();
        if(conditionParam && conditionParam.searchForm){
            conditionParam = conditionParam.searchForm;
        }
        console.log(conditionParam);
        this.$routerUtil.clearParam();
        if(conditionParam){
            this.$nextTick(() => {
                this.searchForm = conditionParam;
                this.doSearch();
            });
        }
    },
    methods: {
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.pageIndex = val;
            this.doSearch();
        },
        handleSelectionChange(val) {
            this.selected = val;
        },
        rowClick(row){
            this.$refs.table.toggleRowSelection(row);
        },
        doSearch() {
            const param = this.$paramUtil.clearEmpty(this.searchForm);
            // 审核时间
            if(this.searchForm.auditTime){
				param.platformAuditDayStart = this.searchForm.auditTime[0];
                param.platformAuditDayEnd = this.searchForm.auditTime[1];
                delete param.auditTime;
            }
            // 申请时间
            if(this.searchForm.applyTime){
				param.applicationTimeStart = this.searchForm.applyTime[0];
				param.applicationTimeEnd = this.searchForm.applyTime[1];
                delete param.applyTime;
            }
            
            this.$axios.get('/api/customerCompay/selectCompanyInfo', {params: param}).then(response => {
                this.tableData = response.data.resultData.rows;
                this.total = response.data.resultData.total;
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        doDetail(){
            const conditionData = new Object();
            conditionData.searchForm = this.searchForm;
            conditionData.row = this.getSelectedRow();
            if (conditionData && conditionData.row) {
                this.$routerUtil.setParam(conditionData);
                this.$router.push('customerDetails');
            }
        },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        },
        doReset(){
            this.$refs.searchForm.resetFields();
        },
    }
}
